<template>
  <v-card outlined class="d-flex flex-column justify-center my-8 mx-16 pa-4">
    <p class="text--secondary">
      Đây là thao tác gửi tin nhắn Sổ điểm hàng ngày. Các thông tin về điểm số của Học viên trong ngày sẽ được tổng hợp
      và gửi tới ứng dụng Sổ liên lạc điện tử của phụ huynh Học viên.
    </p>
    <p class="text--secondary">
      Vui lòng nhập đầy đủ thông tin của Học viên trước khi thực hiện thao tác này. Nếu đã chắc chắn, bạn có thể tích
      vào ô <span class="font-weight-bold">[Xác nhận gửi tin]</span> bên dưới, sau đó nhấn nút
      <span class="font-weight-bold">[Gửi]</span>.
    </p>

    <v-checkbox v-model="checkbox" label="Xác nhận gửi tin" />
    <v-form ref="form">
      <v-row v-if="checkbox" class="mb-1">
        <v-col class="text--secondary mt-2" cols="12" md="4">
          Tổng kết thông tin ngày <span class="error--text">*</span>
        </v-col>
        <v-col cols="12" md="5">
          <DateIOSPicker
            :date.sync="date"
            label="Ngày"
            dense
            outlined
            class="required"
            :rules="[$rules.required, $rules.date, $rules.dateFromNow, $rules.dateRangeFromNow(3)]"
          />
        </v-col>
      </v-row>
    </v-form>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer />
      <v-btn :disabled="!checkbox" @click="sendMarkNoti" depressed color="primary" class="px-6 mt-4 white--text"
        >Gửi</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    DateIOSPicker
  },
  data() {
    return {
      checkbox: false,
      date: ''
    }
  },
  created() {
    this.date = moment().toISOString()
  },
  computed: {
    ...mapGetters('auth', ['profile'])
  },
  methods: {
    ...mapActions('PostCreateAuto', ['sendMarkNotification']),

    async sendMarkNoti() {
      if (!this.$refs.form.validate()) return
      try {
        this.$loading.active = true
        const params = {
          staffId: this.profile.id,
          date: this.date
        }
        await this.sendMarkNotification(params)
        this.$alert.success('Đã gửi tin nhắn Sổ điểm, vui lòng xem chi tiết trong lịch sử gửi tin')
      } catch (error) {
        this.$alert.error(`Đã xảy ra lỗi trong quá trình gửi tin nhắn! Lỗi: ${error}`)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
